import {
    ADMINDELETEBANKMAPPING_SUCCESS,
    ADMINDELETEBANKMAPPING_FAILED,
    RESET_ADMINDELETEBANKMAPPING,
    LOADING_ADMINDELETEBANKMAPPING,
    NETWORK_ERROR_ADMINDELETEBANKMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminDeleteBank = () => {
    return { type: RESET_ADMINDELETEBANKMAPPING };
};

const deleteBankMappingAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINDELETEBANKMAPPING });
    await adminServices
        .post("deleteBankMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminDeleteBankMappingsuccess(res.data));
                    break;
                default:
                    dispatch(AdminDeleteBankMappingFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINDELETEBANKMAPPING,
                payload: err
            });
        });
};


function AdminDeleteBankMappingsuccess(data) {
    return {
        type: ADMINDELETEBANKMAPPING_SUCCESS,
        payload: data
    };
}
function AdminDeleteBankMappingFailed(data) {
    return {
        type: ADMINDELETEBANKMAPPING_FAILED,
        payload: data
    };
}

export { deleteBankMappingAdmin, resetAdminDeleteBank }